import { FC, useState, useMemo } from "react";
import TableAuxiliares from "./TableAuxiliares";
import { auxiliaresLookUps } from "./data/AuxiliaresLookUps";
import SearchTable from "../../components/template/Search/SearchTable";
import { AUXILIAR_SUMMARY, PAGE_SIZE_OPTIONS } from "../../utils/constants";
import { useAuth } from "../../provider/AuthProvider";
import { TableConfig } from "../../types/Components/Table/TableConfig";
import { FilterConfig } from "../../types/Components/Table/FilterConfig";
import useTableRendering from "../../hooks/table/useTableRendering";
import { PaginationConfig } from "../../types/Components/Table/PaginationConfig";

const Auxiliares: FC = () => {
  const { auth } = useAuth();
  const user = auth.user;
  const [pageSize, setPageSize] = useState(PAGE_SIZE_OPTIONS[0]);

  const PERMISSION_STRUCTURAL = "ManageLookups";
  const PERMISSION_NON_STRUCTURAL = "ManageLookupsNational";

  const originalDataTable = useMemo(
    () =>
      auxiliaresLookUps.filter(
        ({ isStructural }) =>
          (isStructural && user.permissions.includes(PERMISSION_STRUCTURAL)) ||
          (!isStructural &&
            user.permissions.includes(PERMISSION_NON_STRUCTURAL)),
      ),
    [user.permissions],
  );

  const [dataTable, setDataTable] = useState(originalDataTable);

  const filterFunction = (item: any, searchTerm: string) =>
    item.name?.toLowerCase().includes(searchTerm.toLowerCase());

  const renderTable = () => {
    return <TableAuxiliares dataTable={dataTable} />;
  };

  const tableConfig: TableConfig = {
    tableName: "Lista de tabelas auxiliares",
    dataTable,
    originalDataTable,
    setDataTable,
    renderTable: renderTable,
    searchTitle: "Pesquisar pelo nome da tabela auxiliar",
  };

  const filterConfig: FilterConfig = {
    filterFunction,
    hasInputSearch: true,
  };

  const { currentPage, totalPages, handlePageChange, renderContent } =
    useTableRendering(tableConfig, pageSize);

  const paginationConfig: PaginationConfig = {
    pageSize,
    currentPage,
    totalPages,
    handlePageChange,
    renderContent,
    setPageSize,
  };

  return (
    <SearchTable
      searchTableName="Tabelas Auxiliares"
      summaryName={AUXILIAR_SUMMARY}
      tableConfig={tableConfig}
      filterConfig={filterConfig}
      paginationConfig={paginationConfig}
    />
  );
};

export default Auxiliares;
